import { Button, IButtonOptions } from "devextreme-react/button";
import "./styles/PromineoHowItWorksButton.css";

export default function PromineoHowItWorksButton(props: IButtonOptions): React.ReactElement {
  const { text, ...rest } = props;

  const getClassNames = () => {
    let className = "promineoHowItWorksButton py-3 font-inter font-bold text-base border-2 border-black h-16 w-550px";
    return className;
  };

  return (
    <Button 
      className={getClassNames()} 
      text={text}
      icon={"chevronnext"}
      {...rest} 
    />
  );
}